<template>
  <el-menu
    default-active="2"
    :collapse="collapsed"
    collapse-transition
    router
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo"
    background-color="#334157"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <div class="logobox">
      <!-- From Uiverse.io by suleymanlaarabidev -->
      <div class="card">
        <div class="first-content">
          <span>小咋</span>
        </div>
        <div class="second-content">
          <span>小咋的后台</span>
        </div>
      </div>
    </div>
    <el-submenu
      v-for="menu in allmenu"
      :key="menu.menuid"
      :index="menu.menuname"
    >
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{ menu.menuname }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item
          v-for="chmenu in menu.menus"
          :index="'/' + chmenu.url"
          :key="chmenu.menuid"
        >
          <i :class="chmenu.icon"></i>
          <span>{{ chmenu.menuname }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
// import { menu } from '../api/userMG'
export default {
  name: "leftnav",
  data() {
    return {
      collapsed: false,
      allmenu: [],
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: "0",
          icon: "el-icon-reading",
          menuname: "任务管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: "01",
              icon: "el-icon-camera",
              menuname: "打卡任务",
              hasThird: "N",
              url: "tasks/tasks",
              menus: null,
            },
            {
              menuid: "02",
              icon: "el-icon-data-line",
              menuname: "全局奖励",
              hasThird: "N",
              url: "configs/configs",
              menus: null,
            },
            {
              menuid: "03",
              icon: "el-icon-data-line",
              menuname: "打卡审核",
              hasThird: "N",
              url: "audits/audits",
              menus: null,
            },
          ],
        },
        {
          menuid: "1",
          icon: "el-icon-shopping-cart-2",
          menuname: "商城管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: "11",
              icon: "el-icon-box",
              menuname: "积分礼品",
              hasThird: "N",
              url: "goods/goods",
              menus: null,
            },
          ],
        },
        {
          menuid: "2",
          icon: "el-icon-document-copy",
          menuname: "订单管理",
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: "21",
              icon: "el-icon-tickets",
              menuname: "订单列表",
              hasThird: "N",
              url: "orders/orders",
              menus: null,
            },
          ],
        },
      ],
      msg: "success",
    };
    this.allmenu = res.data;
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      this.collapsed = !value;
    });
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  /* height: 40px; */
  /* line-height: 40px; */
  /* color: #9d9d9d;
  font-size: 20px;
  text-align: center; */
  padding: 20px 0px;

  display: flex;
  align-items: center;
  justify-content: center;
}
.logoimg {
  height: 40px;
}

/* From Uiverse.io by suleymanlaarabidev */ 
.card {
  width: 150px;
  height: 80px;
  background: rgb(103, 164, 255);
  transition: all 0.4s;
  border-radius: 10px;
  /* box-shadow: 0px 0px 10px 5px  rgba(0, 0, 0, 0.705); */
  font-size: 30px;
  font-weight: 900;
}

.card:hover {
  border-radius: 15px;
  cursor: pointer;
  transform: scale(1.1);
  box-shadow: 0px 0px 10px 5px  rgba(0, 0, 0, 0.705);
  background: #409EFF;
}

.first-content {
  height: 100%;
  width: 100%;
  transition: all 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  border-radius: 15px;
}

.card:hover .first-content {
  height: 0px;
  opacity: 0;
}

.second-content {
  height: 0%;
  width: 100%;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  transition: all 0.4s;
  font-size: 0px;
  transform: rotate(90deg) scale(-1);
  white-space: nowrap;
}

.card:hover .second-content {
  opacity: 1;
  height: 100%;
  font-size: 1.6rem;
  transform: rotate(0deg);
}


</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue